import { render, staticRenderFns } from "./FooterAddressHistory.vue?vue&type=template&id=6c6d88ca&scoped=true"
import script from "./FooterAddressHistory.vue?vue&type=script&lang=ts"
export * from "./FooterAddressHistory.vue?vue&type=script&lang=ts"
import style0 from "./FooterAddressHistory.vue?vue&type=style&index=0&id=6c6d88ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6d88ca",
  null
  
)

export default component.exports